import { ESSENTIALS_CONTENT_CATEGORY } from '../../essentials/types'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** CIS Natural Disaster toolkit */
export const cisNaturalDisasterToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.CIS_NATURAL_DISASTER,
  iFrameSrcUrl: '/natural-disaster-cis-toolkit',
  micrositeUrl: 'natural-disaster-cis-toolkit',
  title: {
    id: 'cisNaturalDisaster.title',
    defaultMessage: 'Support after a natural disaster',
    description: 'Microsite page title',
  },
  featureFlag: 'oct2025ToolkitsEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
      params: {
        category: ESSENTIALS_CONTENT_CATEGORY.TOPIC,
        slug: 'coping-with-crisis',
      },
    },
  ],
  page: 'CIS natural disaster',
  trackUTMParams: {
    utm_campaign: 'CISnaturaldisaster',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'CISnaturaldisaster',
  },
  shouldHideForInternational: true,
}
